const getFormId = ({ formClient }) => formClient.formId;

export default {
  getFormId
};
